import { PencilSquareIcon } from '@heroicons/react/16/solid';
import React, { useState, useEffect } from 'react';
import { getRequest } from '../../utils/APICall';
import { message, Pagination } from 'antd';
import LeaveForm from './LeaveForm';

const LeavesTable = () => {
  const [leavesData, setLeavesData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [editingData, setEditingData] = useState(null);
  const pageSize = 15;

  const T_Head = ["S.NO", "Employee Name", "Leave Type", "Remarks", "From Date", "To Date", "Status", "Action"];

  const fetchLeaves = async () => {
    setLoading(true);
    //console.log("Fetching leave data...");
    try {
      const res = await getRequest('getEmpLeave');
      if (res.success) {
        // console.log("Leaves Fetched:", res.data);
        setLeavesData(res.data || []);
      } else {
        console.error("Fetch failed:", res.message);
        // message.error(res.message || 'Failed to fetch leaves');
        setLeavesData([]);
      }
    } catch (err) {
      console.error("Fetch error:", err);
      message.error('Error fetching leave data');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLeaves();
  }, []);

  const handlePaginationChange = (page) => {
    //console.log("Page changed to:", page);
    setCurrentPage(page);
  };

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    const day = date.getDate().toString().padStart(2, '0'); // 07
    const month = date.toLocaleString('en-US', { month: 'short' }).toUpperCase(); // JUN
    const year = date.getFullYear(); // 2025
    return `${day} ${month} ${year}`;
  };


  const paginatedData = leavesData.slice((currentPage - 1) * pageSize, currentPage * pageSize);
  // console.log("paginatedData", paginatedData);

  return (
    <div className="font-[sans-serif] overflow-x-auto relative">
      <LeaveForm
        editingData={editingData}
        onFinishEdit={() => {
          // console.log("Edit finished, reloading table...");
          setEditingData(null);
          fetchLeaves();
        }}
      />

      {loading ? (
        <table className="min-w-full bg-white dark:bg-darkgray">
          <thead className="bg-primaryPurple dark:bg-lightgrey whitespace-nowrap">
            <tr>
              {T_Head.map((item, index) => (
                <th className="p-4 text-left text-sm md:text-lg font-bold text-white" key={index}>
                  {item}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array(10).fill(0).map((_, rowIndex) => (
              <tr key={rowIndex} className="">
                {T_Head.map((_, colIndex) => (
                  <td
                    key={colIndex}
                    className="p-4 border-b border-gray-100 animate-pulse"
                  >
                    <div className="h-4 bg-gray-300 rounded w-full"></div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      ) : (

        <>
          <table className="min-w-full bg-white dark:bg-darkgray">
            <thead className="bg-primaryPurple dark:bg-lightgrey whitespace-nowrap">
              <tr>
                {T_Head.map((item, index) => (
                  <th className="p-4 text-left text-sm md:text-lg font-bold text-white" key={index}>
                    {item}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="whitespace-nowrap">
              {
                paginatedData.length == 0 ? (
                 <tr className="bg-gray-50 dark:bg-gray-800">
                <td colSpan={8}>
                  <div className="min-h-[200px] sm:min-h-[300px] lg:min-h-[400px]
                    flex flex-col items-center justify-center
                    text-center gap-2">
                    <p className="animate-pulse text-sm sm:text-base font-medium text-gray-800 dark:text-white">
                      Employee Leaves data is currently unavailable
                    </p>
                    <p className="text-xs sm:text-sm text-gray-500 dark:text-gray-400">
                      Please check back later or try refreshing.
                    </p>
                  </div>
                </td>
              </tr>
                )
                  :
                  paginatedData && paginatedData?.map((item, index) => (
                    <tr className="even:bg-blue-50 dark:even:bg-gray-700 dark:bg-gray-800 text-black dark:text-white " key={item.ID || index}>
                      <td className="p-4 text-sm ">{(currentPage - 1) * pageSize + index + 1}</td>
                      <td className="p-4 text-sm ">{item?.FIRSTNAME} {item?.LASTNAME}</td>
                      <td className="p-4 text-sm ">{item?.LEAVETYPE === 1 ? 'Annual Leave' : 'Sick Leave'}</td>
                      <td className="p-4 text-sm ">{item?.REMARKS}</td>
                      <td className="p-4 text-sm ">{formatDate(item?.FROMDATE)}</td>
                      <td className="p-4 text-sm ">{formatDate(item?.TODATE)}</td>
                      <td className="p-4 text-sm ">{item?.LEAVE_STATUS}</td>
                      <td className="p-4 flex items-center">
                        <div
                          className="mr-2 cursor-pointer hover:bg-blue-100 p-1 rounded"
                          onClick={() => {
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                            // console.log("Editing leave with ID:", item.ID);
                            setEditingData(item);
                          }}
                        >
                          <PencilSquareIcon className="h-6 w-6 text-blue-500" />
                        </div>

                        {/* <div className="cursor-not-allowed">
                      <TrashIcon className="h-6 w-6 text-red-500" />
                    </div> */}
                      </td>
                    </tr>
                  ))}
            </tbody>
          </table>

          <div className="flex justify-end   my-4">
            <Pagination
              current={currentPage}
              pageSize={pageSize}
              total={leavesData.length}
              onChange={handlePaginationChange}
              showSizeChanger={false}
               className="dark:text-gray-100 dark:[&_.ant-pagination-item]:bg-gray-400 dark:[&_.ant-pagination-item]:text-white "
            />
          </div>
        </>
      )}
    </div>
  );
};

export default LeavesTable;
